import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectAuthInitializing } from "../../redux/features/authSlice";
import useAuth from "../../hooks/useAuth";
import { Spin } from "antd";

/**
 * AuthProvider
 *
 * Wrap your entire app with this (inside <Provider> but above <RouterProvider>).
 * It starts the Firebase onAuthStateChanged listener exactly once,
 * and shows a full-screen spinner until Firebase resolves the initial auth state.
 *
 * This prevents the flash where a logged-in user briefly sees the login page.
 */
const AuthProvider = ({ children }) => {
	const { initAuthListener } = useAuth();
	const initializing = useSelector(selectAuthInitializing);

	useEffect(() => {
		const unsubscribe = initAuthListener();
		return () => unsubscribe(); // cleanup on unmount
	}, []);

	if (initializing) {
		return (
			<div
				style={{
					height: "100vh",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					background: "#0f1117",
				}}
			>
				<Spin size="large" />
			</div>
		);
	}

	return children;
};

export default AuthProvider;
